import { useCallback } from 'react';

import { httpMethods, IHttpHookResponseAwaitable, useHttpClientAwaitable } from '@services/httpClientService';

import { ApiSectionNamespace } from '../../../apiConstants';

import { mappingFunction } from './mapper';
import { IPaypalProcessResponse, IPaypalProcess, IPaypalProcessRequest } from './model';

export const usePaypalProcessOnDemand = (): IHttpHookResponseAwaitable<IPaypalProcess, IPaypalProcessRequest> => {
  const { request: asyncRequest } = useHttpClientAwaitable<
    IPaypalProcess,
    IPaypalProcessRequest,
    IPaypalProcessResponse
  >({
    method: httpMethods.POST,
    path: ApiSectionNamespace.EPaymentApiKeys.PAYMENT_PAYPAL_PROCESS,
    mappingFunction: mappingFunction,
  });

  const request = useCallback(
    (params?: IPaypalProcessRequest) => {
      return asyncRequest(params && { data: { ...params } });
    },
    [asyncRequest],
  );

  return { request };
};
